<template>
  <div class="drug-guide">
    <div class="icon-container">
      <div class="icon-list">
        <div
          class="icon"
          v-for="item of iconList"
          :key="item.id"
          @click="changeUrl(item.id, item.title)"
        >
          <img :src="item.image" alt="" />
          <div>{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNews } from "@api/public";
export default {
  name: "MedicationGuidance",
  data() {
    return {
      iconList: []
    };
  },
  created() {
    let icon = JSON.parse(sessionStorage.getItem("iconList"));
    if (icon && icon.length > 0) {
      this.iconList = icon;
    } else {
      this.getIconList();
    }
  },
  methods: {
    changeUrl(id, title) {
      this.$router.push({
        path: "departmentClassification",
        query: {
          id: id,
          title: title
        }
      });
    },
    getIconList() {
      getNews().then(res => {
        this.iconList = res.data.cate;
        sessionStorage.setItem("iconList", JSON.stringify(this.iconList));
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.drug-guide
  width 100%
  height 180px
  background-image url('../../../assets/pc/images/index/newsnavbg.jpg')
  background-repeat no-repeat
  background-position center
  .icon-container
    width 1200px
    margin 0 auto
    .icon-list
      padding-top 10px
      margin-left 250px
      width 920px
      display flex
      flex-wrap wrap
      .icon
        width 11.11%
        color #fff
        height 70px
        text-align center
        margin-bottom 15px
        border-radius 4px
        cursor pointer
        &:hover
          background #003081
        img
          width 32px
          height 30px
          margin-top 5px
        div
          font-size 16px
</style>
